<template>
  <v-container>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Qui sommes-nous?</div>
        </template>
        <v-card>
          <v-card-text>
            <p>
              Nous sommes aujourd’hui 4 associés à porter le projet iSignif : Adrien, Antoine, Alexandre et Sacha. Nous avons toujours cru en l'entrepreneuriat. Tous étudiants - en droit et dans l’informatique - nous voulions profiter du temps
              conséquent qui nous est accordé à côté de nos études pour construire quelque chose par nos propres moyens et ainsi mettre en pratique nos connaissances théoriques.
            </p>
            <p>
              Le projet iSignif s'inscrit dans l'accélération récente des LegalTech, qui visent à proposer des services juridiques intelligibles, contournant les frais exorbitants des acteurs traditionnels du milieu. Ainsi, nous voulons dépoussiérer
              l'office d'huissier de justice pour le conformer à l'ère du numérique et offrir activement un service de signification diligent. L'huissier ne doit être plus l’auxiliaire, le subalterne de la justice. Il doit aujourd'hui changer son image
              pour paraître plus proche des citoyens.
            </p>
            <p>
              Il existe aujourd'hui différents réseaux nationaux d'huissiers de justice, toutefois ils n'existent qu'à travers des formes associatives. iSignif a donc une dimension supérieure. La société mettra en place une plateforme moderne et ouverte
              à tous tout en assurant une prospection commerciale de grande envergure pour devenir à terme le premier service national de la signification d'actes juridiques.
            </p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Qu'est-ce qu'une signification ?</div>
        </template>
        <v-card>
          <v-card-text>
            <p>
              La signification par huissier est la procédure visant à notifier un acte de manière officielle. Seul l'huissier de justice est compétent pour signifier un acte. La signification consiste, pour l'huissier de justice, à remettre un acte en
              se rendant au domicile du destinataire. Elle est notamment utilisée dans le cadre d'une procédure judiciaire. L'huissier de justice, dans ce contexte, est amené à signifier les assignations à comparaître d'une part, les décisions de justice
              d'autre part. La signification par huissier de justice présente néanmoins l'avantage d'une sécurité juridique renforcée. Il est obligatoire de faire signifier par huissier les actes suivants :
            </p>
            <ul>
              <li>Les citations à comparaître et les assignations en justice</li>
              <li>Les jugements des tribunaux : arrêts de la Cour d'appel et de la Cour de cassation, sentences arbitrales</li>
              <li>Certains actes extra-judiciaires : congé dans le cadre d'un bail commercial et notification au bailleur de la cession d'un fonds de commerce</li>
            </ul>
            <p>
              Pour donner date et contenu certains à une notification d'acte, il est possible de procéder à une signification
              par Huissier de justice. L'opposition au prix de vente d'un fonds de commerce, le commandement de payer en cas de
              loyers impayés, la cession de créance ou encore une saisie peuvent être notifiées par voie de signification.
            </p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Comment s’inscrire ?</div>
        </template>
        <v-card>
          <v-card-text>
            <p>
              En page d’accueil, cliquez sur « S’inscrire » en haut à droite et remplissez simplement le formulaire classique
              après avoir choisi votre statut d’avocat ou d’huissier de justice. Vous pouvez aussi commencer à remplir votre
              demande de signification puis vous inscrire à sa validation. Vous pourrez ainsi simuler le coût de la signification
              avant de vous inscrire. Le premier mois est gratuit. A la fin de cette période d’essai, vous recevrez un mail pour
              confirmer votre profil d’utilisateur, vous consentez ainsi à la facturation mensuelle de nos services.
            </p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Comment accéder à mon compte ?</div>
        </template>
        <v-card>
          <v-card-text>
            <p>
              En page d’accueil, cliquez sur « Se Connecter » et rentrer votre identifiant mail ainsi que votre mot de passe.
              Vous pouvez aussi commencer à remplir votre demande de signification puis vous inscrire à sa validation. Vous pourrez
              ainsi simuler le coût de la signification avant de vous inscrire.
            </p>
            <p>
              <strong>Mon mot de passe :</strong>
              <br />Nous recommandons le choix d’un mot de passe robuste comprenant a minima des minuscules, des majuscules et des chiffres.
              Pour modifier votre mot de passes, il faut accéder à votre profil en cliquant sur votre nom en haut à droite. Puis,
              « éditez mes informations », il suffira d’inscrire votre nouveau mot de passe puis le confirmer. Lorsque que vous avez
              oublié votre mot de passe, rien de plus simple, cliquez sur « mot de passe oublié ? » sur la page de Connexion. iSignif
              vous demandera votre adresse mail, et vous recevrez un courriel permettant la réinitialisation du mot de passe.
            </p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Vous êtes demandeur de signification:</div>
        </template>
        <v-card>
          <v-card-text>
            <p>Déposer une demande:</p>
            <ul>
              <li>Cliquer sur le bouton « Demander une signification » en page d’accueil avant ou après connexion</li>
              <li>
                Sélectionner la ou les communes à signifier en tapant le code postal ou son nom dans la liste déroulante.
                Ajouter la commune en appuyant sur le petit +, appuyer de nouveau si la commune doit être signifiée une deuxième
                fois. Pour supprimer un choix de commune, appuyer sur la croix placée à droite du bouton bleu de commune
              </li>
              <li>
                Choisir le type d’acte à signifier en tapant le nom dans la liste déroulante. Si vous ne le trouvez pas,
                sélectionner la ligne « Autre ». Le coût simulé est une simple estimation qui n’engage pas iSignif. Le coût final
                sera déterminé par chaque huissier selon les besoins du dossier
              </li>
              <li>
                Votre acte est créé. Compléter la description de votre demande en cliquant sur le bouton bleu « Compléter les
                informations de l’acte » : vous pouvez modifier les Référence de l'acte, les référence de la facture et son
                destinataire (avocat ou tiers), et l’option acte urgent sous 24h peut être cochée
              </li>
              <li>
                Vous pouvez joindre un ou plusieurs fichiers à votre demande, cliquer sur « browse » et sélectionner le fichier
                sur votre ordinateur, donner lui un nom et choisissez la catégorie (acte à signifier, titre à signifier, lettre
                d’instructions, pièce annexe, facture). Cliquer sur ajouter le fichier et répéter l’opération si besoin
              </li>
              <li>
                Dernière étape : Ajouter le nom du destinataire de la signification en cliquant sur le petit crayon en bas à
                droite. Vous pouvez aussi modifier la commune du destinataire, modifier l’huissier de justice mandaté s’il en existe
                d’autres compétents, supprimer un destinataire en cliquant sur la petite poubelle et même ajouter un autre
                destinataire si besoin
              </li>
              <li>
                Confirmez les informations. Votre demande a été transmise aux huissiers de justices compétents sur les
                communes à signifier. Vous serez alerté par mail lors de chaque accusé / réception, chaque significations et lors
                de la fin de mission
              </li>
            </ul>
            <p>
              <strong>Que se passe-t’il lorsque toutes les huissiers compétents ont signifié mon acte ?</strong>
              <br />La mission est terminée, vous recevrez un mail vous indiquant que vous avez 2 mois pour récupérer les factures et actes
              signifiés joints par les huissiers de justice. Ces fichiers seront présents dans la section « Mes Pièces Transmises » de la
              page de l’acte, après 2 mois, nous archiverons le dossier.
            </p>
            <p>
              <strong>Que dois-je faire en cas de changement après la transmission de ma demande ?</strong>
              <br />Une messagerie est disponible dans la page de l’acte en cliquant sur les bulles à la ligne du destinataire posant un
              problème. L’huissier mandaté sera averti par mail de votre message et pourra vous répondre. Sinon, vous pouvez cliquer
              sur le nom de l’huissier mandaté, ses coordonnées sont affichées, vous pourrez le contacter directement sur son mail ou
              téléphone. Au pire, nous vous invitons à nous écrire à contact@isignif.fr ou bien par le formulaire de contact.
            </p>
            <p>
              <strong>Signification urgente :</strong>
              <br />Lors de la création de l’acte, cocher la case « Acte Urgent sous 24h » dans la description de votre demande. L’huissier
              de justice compétent sera averti par SMS, et effectuera la signification sous 24h. Un tarif légal exceptionnel sera appliqué.
            </p>
            <p>
              <strong>Evaluer les missions de significations :</strong>
              <br />Après que votre demande de signification ait été satisfaite, à la clôture du dossier, vous pouvez laisser une note sur 5
              étoiles ainsi qu’un commentaire pour évaluer la mission. Ceci nous aidera à améliorer nos services et à être encore plus
              exigeant avec nos huissiers prestataires.
            </p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Vous êtes huissier de justice :</div>
        </template>
        <v-card>
          <v-card-text>
            <p>TODO</p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Annulation</div>
        </template>
        <v-card>
          <v-card-text>
            <p>TODO</p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Paiements</div>
        </template>
        <v-card>
          <v-card-text>
            <p>TODO</p>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
export default {
  name: "Help"
};
</script>
